import React, { useEffect } from 'react';
import { Hero } from './components/Hero';
import { MessageBand } from './components/MessageBand';
import { PainPoints } from './components/PainPoints';
import { SolutionReveal } from './components/SolutionReveal';
import { VisualSection } from './components/VisualSection';
import { ClassCarousel } from './components/ClassCarousel';
import { TomosSection } from './components/TomosSection';
import { BonusSection } from './components/BonusSection';
import { PricingSection } from './components/PricingSection';
import { ExtendedTestimonials } from './components/ExtendedTestimonials';
import { Guarantee } from './components/Guarantee';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
type MetaPixel = ((...args: unknown[]) => void) & {
  callMethod?: (...args: unknown[]) => void;
  queue: unknown[][];
  loaded?: boolean;
  version?: string;
  push?: MetaPixel;
};
type MetaWindow = Window & {
  fbq?: MetaPixel;
  _fbq?: MetaPixel;
};
const META_PIXEL_ID = '2681835872281557';
export function App() {
  useEffect(() => {
    const w = window as MetaWindow;
    try {
      if (!w.fbq) {
        const pixel = ((...args: unknown[]) => {
          if (pixel.callMethod) {
            pixel.callMethod(...args);
          } else {
            pixel.queue.push(args);
          }
        }) as MetaPixel;
        pixel.queue = [];
        pixel.push = pixel;
        pixel.loaded = true;
        pixel.version = '2.0';
        w.fbq = pixel;
        if (!w._fbq) w._fbq = pixel;
        const script = document.createElement('script');
        script.async = true;
        script.src = 'https://connect.facebook.net/en_US/fbevents.js';
        document.head.appendChild(script);
        w.fbq('init', META_PIXEL_ID);
      }
      w.fbq('track', 'PageView');
    } catch (error) {
      console.warn('Meta Pixel init failed:', error);
    }
  }, []);
  return <div className="min-h-screen bg-cream text-cocoa" data-id="element-0" data-mp="stc8k5naf2of">
      <noscript data-id="element-1" data-mp="36859fxwiety">
        <img height="1" width="1" style={{
        display: 'none'
      }} src={`https://www.facebook.com/tr?id=${META_PIXEL_ID}&ev=PageView&noscript=1`} alt="" data-id="element-2" data-mp="35ymodf6r9ya" />
      </noscript>
      <main data-id="element-3" data-mp="d3cvprys4wgk">
        <Hero data-id="element-4" data-mp="d45v27vesjoo" />
        <MessageBand data-id="element-5" data-mp="d2l7j27ii10b" />
        <PainPoints data-id="element-6" data-mp="85uihpdqbv2r" />
        <SolutionReveal data-id="element-7" data-mp="85bap1hsmn2g" />
        <VisualSection data-id="element-8" data-mp="864a1hefaaak" />
        <ClassCarousel data-id="element-9" data-mp="83i0xdbvvmq8" />
        <TomosSection data-id="element-10" data-mp="3gl4rzijy82kk" />
        <BonusSection data-id="element-11" data-mp="3gklce8hrtq9p" />
        <MessageBand data-id="element-12" data-mp="3glwc9x83idvj" />
        <PricingSection data-id="element-13" data-mp="3gja8m8obsiil" />
        <ExtendedTestimonials data-id="element-14" data-mp="3bmjq7ep1tau0" />
        <Guarantee data-id="element-15" data-mp="3bncorsdusu12" />
        <FAQ data-id="element-16" data-mp="3bnurn7v0u6hy" />
        <FinalCTA data-id="element-17" data-mp="3bk718hkvi07g" />
      </main>
      <Footer data-id="element-18" data-mp="3qaxu7sy7b5c5" />
    </div>;
}